import React from 'react';
import IssuesList from './IssuesList';
import TagsList from './TagsList';

const Repository = ({ repo }) => {
  console.log('Repository data', repo);
  const {
    node: {
      name,
      url,
      owner: { login },
    },
  } = repo;

  return (
    <div className="repository">
      <p>Repo Name: {name}</p>
      <p>Owner: {login}</p>
      <p
        style={{
          cursor: 'pointer',
        }}
      >
        Link:{' '}
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: 'underline' }}
        >
          {url}
        </a>
      </p>

      <div>
        <IssuesList repoName={name} repoOwner={login} />
      </div>
      <div style={{ marginTop: '4px' }}>
        <TagsList tagRepoName={name} TagRepoOwner={login} />
      </div>
    </div>
  );
};

export default Repository;
